import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const campusApi = createApi({
  reducerPath: "campusApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["Campuses", "Users"],
  endpoints: (builder) => ({
    getCampuses: builder.query({
      query: (arg) => {
        let page = 1;
        let search = "";
        if (typeof arg === "number") page = arg;
        else if (arg && typeof arg === "object") {
          page = arg.page || 1;
          search = arg.search || "";
        }
        return {
          url: "/campus",
          method: "GET",
          params: { page, ...(search && { search }) },
        };
      },
      providesTags: ["Campuses"],
    }),
    getMainCampusId: builder.query({
      query: () => "/campus/getmaincampusid",
      providesTags: ["Campuses"],
    }),
    getSingleCampus: builder.query({
      query: (id) => `/campus/${id}`,
      providesTags: ["Campuses"],
    }),
    getIsCampusVp: builder.query({
      query: () => "/campus/iscampusvp",
    }),
    getIsStoreIncharge: builder.query({
      query: () => "/campus/isstoreincharge",
    }),
    createCampus: builder.mutation({
      query: (payload) => ({
        url: "/campus",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Campuses"],
    }),
    updateCampus: builder.mutation({
      query: ({ id, name, address }) => ({
        url: `/campus/${id}`,
        method: "PATCH",
        body: { name, address },
      }),
      invalidatesTags: ["Campuses"],
    }),
    assignCampusVP: builder.mutation({
      query: ({ campusId, userId }) => ({
        url: "/campus/assignvp",
        method: "POST",
        body: { campusId, userId },
      }),
      invalidatesTags: ["Campuses", "Users"],
    }),
    assignStoreIncharge: builder.mutation({
      query: ({ campusId, userId }) => ({
        url: "/campus/assignstoreincharge",
        method: "POST",
        body: { campusId, userId },
      }),
      invalidatesTags: ["Campuses", "Users"],
    }),
    updateCampusVP: builder.mutation({
      query: ({ campusId, userId }) => ({
        url: "/campus/updatevp",
        method: "PATCH",
        body: { campusId, userId },
      }),
      invalidatesTags: ["Campuses", "Users"],
    }),
    updateStoreIncharge: builder.mutation({
      query: ({ campusId, userId }) => ({
        url: "/campus/updatestoreincharge",
        method: "PATCH",
        body: { campusId, userId },
      }),
      invalidatesTags: ["Campuses", "Users"],
    }),
    swapCampusRoles: builder.mutation({
      query: (campusId) => ({
        url: `/campus/swapcampusrole/${campusId}`,
        method: "PATCH",
      }),
      invalidatesTags: ["Campuses", "Users"],
    }),
  }),
});

export const {
  useGetCampusesQuery,
  useGetMainCampusIdQuery,
  useGetIsCampusVpQuery,
  useGetIsStoreInchargeQuery,
  useGetSingleCampusQuery,
  useCreateCampusMutation,
  useUpdateCampusMutation,
  useAssignCampusVPMutation,
  useAssignStoreInchargeMutation,
  useUpdateCampusVPMutation,
  useUpdateStoreInchargeMutation,
  useSwapCampusRolesMutation,
} = campusApi;
